export default "__VITE_PUBLIC_ASSET__2a65e892__"